const env = process.env;

export const AGENCY_NAME = env.REACT_APP_AGENCY_NAME || 'Agency Co.';
export const AGENCY_PASS = env.REACT_APP_AGENCY_PASS || 'agency2026';
export const GREEN = env.REACT_APP_BRAND_GREEN || '#C8F135';
export const BLACK = '#111111';
export const GREEN_LIGHT = '#eef9b0';

export const OB_STEPS = [
  { id: 'agreement',     label: 'Sign Agreement' },
  { id: 'questionnaire', label: 'Brand Questionnaire' },
  { id: 'logins',        label: 'Submit Logins' },
  { id: 'files',         label: 'Upload Brand Files' },
];

export const PLATFORMS = [
  { id: 'shopify',  label: 'Shopify',          fields: ['Store URL', 'Email', 'Password'] },
  { id: 'meta',     label: 'Meta Ads',         fields: ['Business ID', 'Ad Account ID', 'Email', 'Password'] },
  { id: 'google',   label: 'Google Ads',       fields: ['Account ID', 'Email', 'Password'] },
  { id: 'klaviyo',  label: 'Klaviyo',          fields: ['URL', 'Email', 'API Key'] },
  { id: 'ga4',      label: 'GA4',              fields: ['Property ID', 'Email'] },
  { id: 'tiktok',   label: 'TikTok Ads',       fields: ['Ad Account ID', 'Email', 'Password'] },
];

export const QUESTIONS = [
  { id: 'brandName',   label: 'Brand Name',               ph: 'Nova Brand Co.' },
  { id: 'website',     label: 'Website URL',               ph: 'https://...' },
  { id: 'industry',    label: 'Industry / Niche',          ph: 'e.g. Activewear' },
  { id: 'usp',         label: 'What makes you different?', ph: 'Your USP...', multi: true },
  { id: 'audience',    label: 'Target Audience',           ph: 'Age, gender, location...', multi: true },
  { id: 'competitors', label: 'Main Competitors',          ph: 'List 3-5...', multi: true },
  { id: 'goal',        label: 'Primary Goal (90 days)',    ph: 'e.g. $100k/month', multi: true },
  { id: 'budget',      label: 'Monthly Ad Budget',         ph: 'e.g. $5,000' },
  { id: 'challenges',  label: 'Current Challenges',        ph: 'What is not working?', multi: true },
];

export const AGREEMENT_TEXT = `SERVICE AGREEMENT

This Agreement is between ${AGENCY_NAME} ("Agency") and the signing party ("Client").

1. SERVICES
Agency will provide digital marketing services including paid media management, email marketing, creative production, and strategy consulting as outlined in the proposal.

2. TERM
Month-to-month from the date of signing. Either party may terminate with 30 days written notice.

3. PAYMENT
Monthly retainer invoiced on the 1st, due within 7 days. Late payments incur a 5% monthly surcharge.

4. INTELLECTUAL PROPERTY
Creative assets remain Agency property until final payment, then transfer to Client. Agency retains portfolio rights.

5. CONFIDENTIALITY
Both parties keep all shared information confidential during and for 2 years after the engagement.

6. AD SPEND
Client funds all ad accounts. Agency is not liable for spend losses, platform changes, or account suspensions.

7. RESULTS
Monthly reports provided. No specific results guaranteed.

8. LIABILITY
Agency liability capped at fees paid in the prior month.

9. GOVERNING LAW
Laws of Agency operating jurisdiction apply.

By typing your full name below you confirm you have read and agree to all terms above.`;
